import React from "react";
import Loading from "./Loading";

import logo from "../../images/header-logo.png";

const PageLoading = () => {
  return (
    <div className="w-full h-full fixed bg-black flex justify-center items-center backdrop-blur-md bg-opacity-20 z-[9999999]">
      <div className="w-60 h-44 flex flex-col gap-2 bg-gray-800 rounded-xl justify-center items-center">
        {/* <h2 className="text-xl text-yellow-700 font-black">یونی بست</h2> */}
        <img src={logo} className="w-28" alt="" />

        <Loading />
        {/* <span className="line-loader"></span> */}
      </div>
    </div>
  );
};

export default PageLoading;
